import { createStyles } from "@mantine/core";
import arcLogo from "../assets/img/arc.png";
import t from "../stores/language";
import { version } from "../package.json";

const useStyles = createStyles((theme) => ({
  container: {
    fontSize: theme.fontSizes.sm,
    display: "flex",
    alignContent: "center",
    marginTop: theme.other.arc.margins[2],
    alignItems: "stretch",
    float: "right",
  },
  infoveaveLogo: {
    marginLeft: theme.other.arc.margins[1],
    marginRight: theme.other.arc.margins[1],
    height: theme.other.imageHeight.xxs,
    marginTop: "-6px",
    alignContent: "center",
  },
  rights: {
    fontSize: theme.fontSizes.sm,
    display: "flex",
    alignContent: "center",
    marginTop: theme.other.arc.margins[2],
    marginLeft: theme.other.arc.margins[1],
    alignItems: "stretch",
    float: "left",
  },
  clientLogo: {
    marginLeft: theme.other.arc.margins[1],
    height: theme.other.imageHeight.xs,
    alignContent: "center",
  },
}));
const Footer = () => {
  const { classes } = useStyles();
  const currentYear = new Date().getFullYear();
  return (
    <>
      <p className={classes.rights}>
        {currentYear === 2023 ? t("©2023 All rights reserved") : t(`2023-${currentYear} All rights reserved`)}
        <a href="https://www.arc360.com.au/" target="_blank" rel="noreferrer">
          <img className={classes.clientLogo} src={arcLogo} alt="logo" />
        </a>
        <span style={{ marginLeft: "10px" }}>version: {version}</span>
      </p>
      <p className={classes.container} style={{ gap: "20px" }}>
        <a href="https://www.arc360.com.au/privacy-policy" target="_blank" rel="noreferrer">
          {t("Privacy Policy")}
        </a>
        <a href="https://www.arc360.com.au/release-notes" target="_blank" rel="noreferrer">
          {t("Release Notes")}
        </a>
      </p>
      <p className={classes.container}>
        {t("Powered by ")}
        <a
        // href="https://infoveave.com/"
        // target="_blank" rel="noreferrer"
        >
          <img className={classes.infoveaveLogo} src={"https://cdn.infoveave.com/infoveave_lightbg.svg"} alt="logo" />
        </a>
      </p>
    </>
  );
};
export default Footer;
